import { Component, DestroyRef, Directive, HostListener, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-community-resources-dialog',
  template: `
    <div [innerHTML]="content"></div>
    <div class="pt-4 flex justify-end">
      <button
        pButton
        aria-label="Go to Community Resources"
        type="button"
        icon=""
        label="Go to Community Resources"
        (click)="onSubmit()"
      ></button>
    </div>
  `,
  imports: [ButtonModule]
})
export class CommunityResourcesDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  content: string;

  constructor() {
    const config = this.config;

    this.content = config.data.html;
  }

  onSubmit(): void {
    this.ref.close(true);
  }
}

@Directive({
  selector: '[communityResourcesDialog]',
  providers: [DialogService],
  standalone: true
})
export class CommunityResourcesDialogDirective {
  private readonly dialogService = inject(DialogService);
  private window = inject<Window>('windowRef' as any);

  private destroyRef = inject(DestroyRef);

  @HostListener('click') onClick(): void {
    const message =
      'Please click the button below to view community resources available in your member’s ZIP Code.';
    const urlService = 'https://anthembcbs.auntbertha.com/';
    const ref = this.dialogService.open(CommunityResourcesDialogComponent, {
      header: 'Go to Community Resources',
      width: '70%',
      closable: true,
      data: {
        html: `${message} <br/><a href="${urlService}" target="_blank" class="text-primary-400">${urlService}</a>`
      }
    });

    ref?.onClose
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => res && this.window.open(urlService));
  }
}
